// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_base-selection-panel-group-8b164be7cb53dd9337af9604b03e19d2","title":"_base-selection-panel-group-7c3428be6fca271fba49b692a394906c"};